export const URL_FACEBOOK = "https://www.facebook.com/iynkapp"
export const URL_INSTAGRAM = "https://www.instagram.com/iynk.app"
